export default __webpack_public_path__ + "static/img-olive-tree-capital-536b23f955a550b5d6d33721546a5ebd.png";